import React from 'react';
import { Row, Col } from 'react-bootstrap';
import linkArrow from '@/../style/linkarrow.png';

export const ConnectButton = (props) => {
  const connectedDealStyle = { flexGrow: 1, minWidth: '300px',
    flexDirection: !props.position || props.position == 'right' ? 'column' : 'row-reverse',
    zIndex: '1', display: 'flex', paddingRight: 0, paddingLeft: 0 };
  return (
    <Row
      style={{ display: 'flex', flexGrow: 1, zIndex: 3,
        justifyContent: 'center', alignSelf: 'center', marginBottom: '10px' }}
    >
      {!props.position || props.position == 'left' ?
        <Col md={6} style={connectedDealStyle}>
          {props.connectDeal ? props.connectDeal : ''}
        </Col>
        : ''}
      <Col
        className={'new-link-arrow-block'}
        md={6} style={{ padding: '15px', display: 'flex', flexDirection: 'column',
          justifyContent: 'center' }}
      >
        <img className={'link-arrow'} src={linkArrow} alt={''} />
        <div style={{ position: 'absolute', alignSelf: 'center' }}>
          {props.connectTransport ? props.connectTransport : ''}
        </div>
      </Col>
      {!props.position || props.position == 'right' ?
        <Col md={6} style={connectedDealStyle}>
          {props.connectDeal ? props.connectDeal : ''}
        </Col>
        : ''}
    </Row>
  );
};

ConnectButton.propTypes = {
  position: React.PropTypes.string,
  connectDeal: React.PropTypes.object,
  connectTransport: React.PropTypes.object,
};
